import React, { useState, useEffect } from 'react'
import * as ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import * as wjCore from '@mescius/wijmo'
import * as wjMultiRow from '@mescius/wijmo.react.grid.multirow'
import { KeyAction, DataMap } from '@mescius/wijmo.grid'
import '@mescius/wijmo.cultures/wijmo.culture.ja'
import customContextMenu from '../../wijmo/customContextMenu'
import editableFlexGridInitialize from '../../wijmo/editableFlexGridInitialize'
import colElements from '../../wijmo/columnElements'
import ErrorBoundary from '../ErrorBoundary'

function getLayoutDefs (isReadOnly, subCategories, stampId) {
  const subCategoryDataMap = new DataMap([{ id: '', name: '（未設定）' }].concat(subCategories), 'id', 'name')
  const ldTwoLines = [
    {
      colspan: 3,
      cells: [
        { width: 0, maxWidth: 0, rowspan: 2 },
        { ...colElements.id, rowspan: 2 },
        { ...colElements.name, rowspan: 2, width: 250 }
      ]
    },
    {
      colspan: 2,
      cells: [
        colElements.price,
        colElements.rate_decimal,
        { ...colElements.royality, colspan: 2 }
      ]
    },
    {
      colspan: 1,
      cells: [
        { ...colElements.comment, rowspan: 2, cssClassAll: 'wj-style-basic' }
      ]
    },
    {
      colspan: 3,
      cells: [
        (stampId === '000' || stampId === '999')
          ? { ...colElements.stamp_notice, isReadOnly: isReadOnly, cssClassAll: isReadOnly ? 'wj-style-green' : 'wj-style-green-input', dataMap: new DataMap([stampId === '000' ? '印刷' : '免除']) }
          : { ...colElements.stamp_notice, isReadOnly: isReadOnly, cssClassAll: isReadOnly ? 'wj-style-green' : 'wj-style-green-input' },
        { ...colElements.ratio_stamp },
        { ...colElements.ratio_item, isReadOnly: isReadOnly, cssClassAll: isReadOnly ? 'wj-style-green' : 'wj-style-green-input' },
        { ...colElements.stamp_name, colspan: 3 }
      ]
    },
    {
      colspan: 1,
      cells: [
        {
          ...colElements.category,
          isReadOnly: isReadOnly,
          cssClassAll: isReadOnly ? 'wj-style-green' : 'wj-style-green-input',
          cellTemplate: null
        },
        {
          ...colElements.sub_category,
          isReadOnly: isReadOnly,
          cssClassAll: isReadOnly ? 'wj-style-green' : 'wj-style-green-input',
          dataMap: subCategoryDataMap,
          cellTemplate: null
        }
      ]
    }
  ]
  return {
    def: ldTwoLines
  }
}

//
export default function ItemsCategoryGrid (props) {
  const stampId = props.stampId
  const [itemsCV, setItemsCV] = useState(null)
  const [layoutDef] = useState(getLayoutDefs(props.readonly, props.subCategories, stampId))
  const [itemsJson, setItemsJson] = useState(null)
  const [commonCategory, setCommonCategory] = useState('')
  const [commonSubCategory, setCommonSubCategory] = useState('')

  // インポート/エクスポート時のテーブルを定義
  const tableFormat = [
    { field: 'serial_no', text: 'No', type: 'string', isEditable: false },
    { field: 'name', text: '商品名', type: 'string', isEditable: false },
    { field: 'price', text: '税抜小売価格', type: 'number', isEditable: false },
    { field: 'rate_decimal', text: '料率', type: 'number', isEditable: false },
    { field: 'royality', text: '使用料単価', type: 'number', isEditable: false },
    { field: 'comment', text: '備考', type: 'string', isEditable: false },
    { field: 'category', text: '大分類', type: 'string', isEditable: false },
    { field: 'sub_category', text: '小分類', type: 'string', isEditable: false }
  ]

  useEffect(() => {
    if (!itemsCV) {
      const oldItems = new Map(props.oldItems.map((item) => [item.id, item]))
      const items = props.items
      const inputFields = 'id,stamp_notice,ratio_stamp,ratio_item,category,sub_category_id'.split(',')
      items.map((item, i) => {
        if (oldItems[item.id]) {
          item.category = oldItems[item.id].category
          item.sub_category_id = oldItems[item.id].sub_category_id
        }
        item.rate = 'rate' in item ? Number(item.rate) : null
        item.royality = 'royality' in item ? Number(item.royality) : null

        if (!item.category) {
          item.category = ''
        }
        if (!item.sub_category_id) {
          item.sub_category_id = ''
        }

        if (stampId === '000') {
          item.stamp_notice = '印刷'
          item.ratio_item = 1
        } else if (stampId === '999') {
          item.stamp_notice = '免除'
          item.ratio_item = 1
        }

        delete item.ratio_stamp
        return 0
      })
      const subCategoryMap = new Map(props.subCategories.map((category) => [category.id, category.name]))
      const _itemsCV = new wjCore.CollectionView(items, {
        calculatedFields: {
          rate_decimal: (obj) => 'rate' in obj ? obj.rate / 100 : null,
          sub_category: (obj) => subCategoryMap.get(obj.sub_category_id) ?? '',
          ratio_stamp: (obj) => obj.stamp_notice === '免除' || obj.stamp_notice === '印刷' ? 0 : 1
        }
      })
      _itemsCV.collectionChanged.addHandler((cv, e) => {
        // アイテム情報のJSONを隠し要素に記録（フォーム送信時に参照する）
        setItemsJson(JSON.stringify(_itemsCV.items, inputFields))
      })
      setItemsJson(JSON.stringify(_itemsCV.items, inputFields))

      setItemsCV(_itemsCV)

      // 契約カテゴリのinputにハンドラを設定、カテゴリ未設定のアイテムにデフォルト値を設定
      $('input[name="category"]').each((i, el) => {
        if (props.detectCommonCategoryChange) {
          $(el).on('change', (e) => {
            setCommonCategory(e.target.value)
          })
        }
        if (!props.readonly) {
          _itemsCV.items.forEach((item) => {
            if (item.category === '') {
              item.category = el.value
            }
          })
          _itemsCV.refresh()
        }
      })
      $('input[name="sub_category_id"]').each((i, el) => {
        if (props.detectCommonCategoryChange) {
          $(el).on('change', (e) => {
            setCommonSubCategory(e.target.value)
          })
        }
        if (!props.readonly) {
          _itemsCV.items.forEach((item) => {
            if (item.sub_category === '') {
              item.sub_category_id = el.value
            }
          })
          _itemsCV.refresh()
        }
      })
    }
  }, [])

  useEffect(() => {
    // アイテム毎のカテゴリを契約カテゴリに合わせる
    if (itemsCV && !props.readonly) {
      itemsCV.items.forEach((item) => {
        item.category = commonCategory
      })
      itemsCV.refresh()
    }
  }, [commonCategory])

  useEffect(() => {
    // アイテム毎のカテゴリを契約カテゴリに合わせる
    if (itemsCV && !props.readonly) {
      itemsCV.items.forEach((item) => {
        item.sub_category_id = commonSubCategory
      })
      itemsCV.refresh()
    }
  }, [commonSubCategory])

  function getIsEditable (item, column) {
    if (column.binding === 'stamp_notice') {
      return item.used_amount === 0 // 証紙情報の変更は今まで製造したことがないアイテムに限る
    } else if (column.binding === 'ratio_item') {
      return item.used_amount === 0 && // 証紙情報の変更は今まで製造したことがないアイテムに限る
             item.stamp_notice === '代表'
    } else {
      return true
    }
  }

  const gridInit = (grid) => {
    grid.formatItem.addHandler((s, e) => {
      if (e.panel === s.cells) {
        const item = e.getRow().dataItem
        const column = grid.getBindingColumn(e.panel, e.row, e.col)
        // 編集不可の行のスタイル変更
        if (e.cell.classList.contains('wj-style-green-input')) {
          if (!getIsEditable(item, column)) {
            wjCore.removeClass(e.cell, 'wj-style-green-input')
            wjCore.addClass(e.cell, 'wj-style-green')
          }
        }
      }
    })

    grid.beginningEdit.addHandler((s, e) => {
      const item = e.getRow().dataItem
      const column = grid.getBindingColumn(e.panel, e.row, e.col)
      if (!getIsEditable(item, column)) {
        e.cancel = true
      }
    })

    grid.cellEditEnding.addHandler((s, e) => {
      const column = s.getBindingColumn(e.panel, e.row, e.col)
      if (column.binding === 'stamp_notice') {
        if (grid.activeEditor.value !== '代表') {
          // 掛率数量をリセット
          grid.setCellData(e.row, e.col + 2, 1)
        }
      }
    })

    grid.tableFormat = tableFormat
    customContextMenu(grid)
    editableFlexGridInitialize(grid)
  }

  return (
    <div className="text-center w-100">
      <div className="d-inline-block mw-100">
        <wjMultiRow.MultiRow showMarquee={true} stickyHeaders={true} itemsSource={itemsCV} layoutDefinition={layoutDef.def}
          keyActionTab={KeyAction.Cycle} initialized={gridInit}
          style={{ maxHeight: '500px' }}
        >
        </wjMultiRow.MultiRow>
      </div>
      <input type="text" name="items_category_json" id="items_category_json" value={itemsJson ?? ''} readOnly className="d-none" />
    </div>
  )
}

ItemsCategoryGrid.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  subCategories: PropTypes.arrayOf(PropTypes.object),
  readonly: PropTypes.bool,
  stampId: PropTypes.string,
  oldItems: PropTypes.arrayOf(PropTypes.object),
  detectCommonCategoryChange: PropTypes.bool
}

ItemsCategoryGrid.defaultProps = {
  oldItems: [],
  readonly: false,
  detectCommonCategoryChange: true
}

$('#items-category-grid').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  props.stampId = props.stampId.toString()

  ReactDOM.render(
    <ErrorBoundary>
      <ItemsCategoryGrid {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
